<template>
  <b-row class="quiz" id="quiz" data-toggle="buttons">
    <b-col lg="3" v-for="item in types" :key="item.type" class="p-1">
      <b-button
        :variant="'outline-' + item.color"
        @click="selectedType(item)"
        style="height: 120px"
        block
        :class="active(item)"
      >
        <feather-icon :icon="item.icon" />
        {{ item.title }}</b-button
      ></b-col
    >
  </b-row>
</template>

<script>
import EduCoursesController from "@/Controllers/EduCoursesController";
import config from "../../../../config/config";

export default {
  data() {
    return {
      accept: "",
      type: "",
      src: "",
      iframeWin: {},
    };
  },
  mounted() {},
  created() {
    this.types = new EduCoursesController().Types();
  },
  methods: {
    active(item) {
      if (this.type == item.type) {
        return "active";
      }
    },
    returnData() {
      if (this.type == "") return { valid: false };
      return { valid: true, type: this.type, accept: this.accept };
    },
    selectedType(item) {
      console.log(item);
      this.$set(this, "type", item.type);
      this.$set(this, "src", config.serverUrl + "/editor?type=" + this.type);
      switch (item.type) {
        case "uploaded_voice_lectures":
          this.accept = "audio/*";
          break;
        case "pdf":
          this.accept = "application/pdf";
          break;
        case "powerpoint_lectures":
          this.accept = ".ppt,.pptx";
          break;
        case "scrom_lectures":
          this.accept = ".zip,.rar";
          break;
        case "video_lectures":
          this.accept = "video/*";
          break;
      }
    },
  },
};
</script>

<style>
</style>